module.exports = __webpack_public_path__ + "img/user.1bdab980.jpeg";